import { AllPhotosList, AllPhotosListProps } from './all-photos-list';
import withEvents from 'analytics/withEvents';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { setReportListingPopupOpen } from 'store/state/app/actions';
import { navigateTo } from 'store/state/router/actions';
import { routeSelector } from 'store/state/selectors/router';

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
});

const mapDispatchToProps = {
  openReportListingPopup: () => setReportListingPopupOpen(true),
  navigateTo,
};

const ConnectedAllPhotosList = connect(mapStateToProps, mapDispatchToProps)(AllPhotosList);

const withEventsAllPhotosList = withEvents<AllPhotosListProps>((sendEvent) => ({
  eventViewPhotoGalleryOpen({ image, index, total }) {
    sendEvent('property_view_photo_gallery_image_click', 'property', {
      event: {
        image: {
          description: image.description,
          image_url: image.url,
          isFloorPlanPhoto: false,
        },
        image_index: index,
        index_total: total,
      },
    });
  },
  openReportListingPopup() {
    sendEvent('property_mistake_click', 'property');
  },
}))(ConnectedAllPhotosList);

export default withEventsAllPhotosList;
